// Import auth service for authenticated requests
import { authService } from './authService';
import { getServerURL } from './config';

// Scenes Service for CRUD operations
const SERVER_URL = getServerURL();

export const scenesService = {
  // Get all scenes
  async getAllScenes() {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/`, {
        headers: authService.getAuthHeaders(),
      });
      if (response.ok) {
        const data = await response.json();
        return Array.isArray(data.data) ? data.data : [];
      } else {
        throw new Error(`Failed to fetch scenes: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching scenes:', error);
      return [];
    }
  },

  // Get deleted scenes
  async getDeletedScenes() {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/deleted/`, {
        headers: authService.getAuthHeaders(),
      });
      if (response.ok) {
        const data = await response.json();
        return Array.isArray(data.data) ? data.data : [];
      } else {
        throw new Error(`Failed to fetch deleted scenes: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching deleted scenes:', error);
      return [];
    }
  },

  // Get scene by ID
  async getSceneById(id) {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/${id}/`, {
        headers: authService.getAuthHeaders(),
      });
      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(`Failed to fetch scene: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching scene:', error);
      throw error;
    }
  },

  // Create scene
  async createScene(sceneData) {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/`, {
        method: 'POST',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify(sceneData),
      });
      if (response.ok) {
        return await response.json();
      } else {
        let errorData = {};
        try { errorData = await response.json(); } catch {}
        throw new Error(`Failed to create scene: ${response.status} - ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error creating scene:', error);
      throw error;
    }
  },

  // Update scene
  async updateScene(id, sceneData) {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/${id}/`, {
        method: 'PUT',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify(sceneData),
      });
      if (response.ok) {
        return await response.json();
      } else {
        let errorData = {};
        try { errorData = await response.json(); } catch {}
        throw new Error(`Failed to update scene: ${response.status} - ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error updating scene:', error);
      throw error;
    }
  },

  // Delete scene
  async deleteScene(id) {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/${id}/`, {
        method: 'DELETE',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify({ text: `Scene with ID ${id}` }),
      });
      if (response.ok) {
        return await response.json();
      } else {
        let errorData = {};
        try { errorData = await response.json(); } catch {}
        throw new Error(`Failed to delete scene: ${response.status} - ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error deleting scene:', error);
      throw error;
    }
  },

  // Restore scene
  async restoreScene(id) {
    if (!SERVER_URL) throw new Error('API server URL is not configured');
    try {
      const response = await fetch(`${SERVER_URL}/previewer-scenes/${id}/restore/`, {
        method: 'PATCH',
        headers: authService.getAuthHeaders(),
      });
      if (response.ok) {
        return await response.json();
      } else {
        let errorData = {};
        try { errorData = await response.json(); } catch {}
        throw new Error(`Failed to restore scene: ${response.status} - ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error restoring scene:', error);
      throw error;
    }
  },
}; 